// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j3-3";
export var downloadButton = "_j3-4";
export var fileContainer = "_j3-9 _j3-7";
export var fileContainerBase = "_j3-7";
export var fileContainerFixedHeight = "_j3-8 _j3-7";
export var fileInfo = "_j3-5";
export var fileInfoWidthRestricted = "_j3-6";
export var fileType = "_j3-1";
export var fileTypeName = "_j3-2";
export var image = "_j3-0";
export var link = "_j3-b";
export var overflowEllipsis = "_j3-a";